import { ReactNode } from "react";

interface FilterWrapperProps {
  label: string;
  children: ReactNode;
}

export const FilterWrapper: React.FC<FilterWrapperProps> = ({ label, children }) => {
  return (
    <div className="flex flex-col">
      <label className="block text-sm/6 font-medium text-gray-900 mb-1">{label}</label>
      {children}
    </div>
  );
};
